export enum UltimateBeneficialOwnerCompanyPosition {
  Shareholder = 'SHAREHOLDER',
  Director = 'DIRECTOR',
  Other = 'OTHER',
}

export interface UpdateUltimateBeneficialOwner {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  middleName: string;
  ownershipPercentage: number;
  position: UltimateBeneficialOwnerCompanyPosition;
}

export interface NewUltimateBeneficialOwner {
  email: string;
  firstName: string;
  lastName: string;
  middleName: string;
  ownershipPercentage: number;
  position: UltimateBeneficialOwnerCompanyPosition;
}
